import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';

@Injectable()
/**
 * Tracking via GA / Firebase Analytics
 */
export class Tracking {


  ga : GoogleAnalytics;

id = 'UA-91303680-3';
//id = '1:318112417231:ios:f8df9d896a8e075d';
//id = 'AIzaSyCvcspBUlGyIa8s_5w3_Hl2TWpp0VVw864';

  constructor(public platform: Platform) {

//     this.platform.ready().then(() => {

//       this.ga = new GoogleAnalytics();
//       this.ga.startTrackerWithId(this.id, 5).then(() => {
      
//         console.log('Google analytics is ready now');

// //this.ga.setUserId()        // Tracker is ready
//         // You can now track pages or set additional information such as AppVersion or UserId

//       }).catch(e => console.log('Error starting GoogleAnalytics', e));
      
         
//     });

  }

  init( fct ) {

    this.platform.ready().then(() => {

      if (!this.ga) {
        
        this.ga = new GoogleAnalytics();
        this.ga.startTrackerWithId(this.id, 5).then(() => {
      
          console.log('Google analytics is ready now');

          this.ga.setAllowIDFACollection(true);

          // Voir https://learnionic2.com/2017/04/04/getting-app-version-ionic-2-application/
          this.ga.setAppVersion( "1.0" );

          this.ga.enableUncaughtExceptionReporting(true);

          //this.ga.setUserId()        // Tracker is ready
          // You can now track pages or set additional information such as AppVersion or UserId
this.ga.debugMode();



          fct();

        }).catch(e => console.log('Error starting GoogleAnalytics', e));
        return;
      }

      fct();
    });
  }

/*

  https://developers.google.com/analytics/devguides/collection/firebase/ios/

  https://github.com/danwilson/google-analytics-plugin#sdk-files

  https://www.npmjs.com/package/angulartics
*/

  userId(uid) {
    this.init( ()=> { this.ga.setUserId(uid);  });
  }

  view(page) {
    // , "www.in3dc.com/membership", true); 

    let name;
    if (typeof page === 'string') name = page;
    else {
      name = page.constructor.name;
      if (!name) name = page.name;
    }
    
console.log('Tracking view ' + name);      
    // this.init( ()=> { this.ga.trackView(page.name, '/' + page.name, true);  });
    this.init( ()=> { this.ga.trackView(name);  });
  }

  event(category : string, action : string, label : string, value:number, newSession:boolean) {
    this.init( ()=> {this.ga.trackEvent(category, action, label, value, newSession);  });
  }

  metric(key : string, value : any) {
    this.init( ()=> {this.ga.trackMetric(key, value);  });  
  }

  customDimension(key : number, value : any) {
    this.init( ()=> {this.ga.addCustomDimension(key, value);  });  
  }


  // https://ionicframework.com/docs/native/google-analytics/
}




// WEBPACK FOOTER //
// ./src/providers/tracking.ts